import { Phone, MessageCircle } from "lucide-react";
import Navigation from "@/components/Navigation";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";
import MobileStickyBar from "@/components/MobileStickyBar";
import Seo, { businessSchema } from "@/components/seo/Seo";

export default function ContactPage() {
  return (
    <div className="min-h-screen bg-[#0284FC]">
      <Seo
        title="Contact & devis covering cuisine | Vinylux"
        description="Contactez Vinylux pour votre projet de rénovation de cuisine par covering dans l'Ain, Lyon, Villefranche-sur-Saône et alentours. Devis gratuit."
        path="/contact"
        schema={businessSchema}
      />
      <Navigation />
      <main className="pb-20 lg:pb-0">
        <section className="pt-32 lg:pt-[180px] pb-10 bg-[#0284FC] text-white">
          <div className="max-w-5xl mx-auto px-6 sm:px-8 lg:px-12 text-center">
            <div className="inline-flex bg-white/15 text-white px-4 py-1.5 rounded-full text-sm font-semibold mb-6">Contact Vinylux</div>
            <h1 className="font-heading text-4xl sm:text-5xl lg:text-6xl font-black tracking-tighter mb-6">Parlons de votre cuisine</h1>
            <p className="text-lg text-white/80 leading-relaxed max-w-3xl mx-auto">Pour un premier avis, envoyez quelques photos de la cuisine, votre commune et ce que vous souhaitez transformer. Je pourrai rapidement vous dire si le covering est adapté.</p>
            <div className="mt-8 flex flex-col sm:flex-row justify-center gap-3">
              <a href="tel:+33695134999" className="inline-flex items-center justify-center gap-2 bg-white text-[#0284FC] font-bold px-6 py-3 rounded-full"><Phone className="w-4 h-4" /> 06 95 13 49 99</a>
              <a href="#contact" className="inline-flex items-center justify-center gap-2 border border-white/30 text-white font-bold px-6 py-3 rounded-full"><MessageCircle className="w-4 h-4" /> Formulaire de devis</a>
            </div>
          </div>
        </section>
        <ContactSection />
      </main>
      <Footer />
      <MobileStickyBar />
    </div>
  );
}
